export { default } from './InstallationOnlyModalConnector';
